
import { Gender } from "./Gender";
import { Validation } from "./Validation";
import ImageJson, { validateImageJson, validateImageJsonAdd } from "./ImageJson";
import DemoServer from "./DemoServer";
import CustomInputJson, { validateCustomInputJson } from "./CustomInputJson";

/**
 * Kontakt Daten für zukünftig alle Bereiche in denen Kontakt Daten benötigt werden.
 */
export default interface ContactJson {
   ID: number | null;

   type: string;
   remarks: string,
   salutation: string;
   title: string;
   gender: Gender | null;
   firstName: string;
   lastName: string;

   organisation: string;
   organisationUnit: string;
   organisationPosition: string;

   email: string;
   emailWork: string;

   phone: string;
   phoneWork: string;
   mobile: string;
   mobileWork: string;
   fax: string;
   faxWork: string;

   url: string;

   addressStreet: string;
   addressZip: string;
   addressCity: string;
   addressRegion: string;
   addressCountry: string;

   addressStreetWork: string;
   addressZipWork: string;
   addressCityWork: string;
   addressRegionWork: string;
   addressCountryWork: string;

   idDocuments: ImageJson[];

   birthDate: string | null;
   gradeLevel: number | null;
   holidayBookingGroup: string;

   /**
    * Eingaben der individuellen Form Inputs
    */
   customInputs: CustomInputJson[];
}

export type ContactMailingJson = Pick<ContactJson, "ID" | "salutation" | "firstName" | "lastName" | "organisation" | "email">;

export function defaultContactJson(): ContactJson {
   return {
      ID: null,
      type: "",
      remarks: "",
      salutation: "",
      title: "",
      gender: null,
      firstName: "",
      lastName: "",
      organisation: "",
      organisationUnit: "",
      organisationPosition: "",
      email: DemoServer.isActive ? DemoServer.demoEmail : "",
      emailWork: DemoServer.isActive ? DemoServer.demoEmail : "",
      phone: "",
      phoneWork: "",
      mobile: "",
      mobileWork: "",
      fax: "",
      faxWork: "",
      url: "",
      addressStreet: "",
      addressZip: "",
      addressCity: "",
      addressRegion: "",
      addressCountry: "",
      addressStreetWork: "",
      addressZipWork: "",
      addressCityWork: "",
      addressRegionWork: "",
      addressCountryWork: "",
      idDocuments: [],
      birthDate: null,
      gradeLevel: null,
      holidayBookingGroup: "",
      customInputs: [],
   };
}

export function defaultContactMailingJson(): ContactMailingJson {
   return {
      ID: null,
      salutation: "",
      firstName: "",
      lastName: "",
      organisation: "",
      email: DemoServer.isActive ? DemoServer.demoEmail : "",
   };
}

export function getContactAge(birthdayString: string, dateString: string | null = null): number {
   //if (!birthdayString) return undefined;

   var birthdayDate = new Date(birthdayString);
   var testDate = dateString ? new Date(dateString) : new Date();
	
   let age = testDate.getFullYear() - birthdayDate.getFullYear();

   if (
      testDate.getMonth() < birthdayDate.getMonth() ||
      (testDate.getMonth() === birthdayDate.getMonth() &&
      testDate.getDate() < birthdayDate.getDate())
   ) {
      age--;
   }

	return age;
}


export function validateClientContactJsonAddNew(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email", true)
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validatePastDate("birthDate", true)
      .validateAllUsingFunction("idDocuments", validateImageJsonAdd, 0, false, 4)
      .validateNumber("gradeLevel", 0, 15, true)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateClientContactMailJsonAddNew(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email")
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validatePastDate("birthDate", true)
      .validateNumber("gradeLevel", 0, 15, true)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateClientContactJson(item: ContactJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email", true)
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validatePastDate("birthDate", true)
      .validateAllUsingFunction("idDocuments", validateImageJsonAdd, 0, false, 4)
      .validateNumber("gradeLevel", 0, 15, true)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateClientContactMailJson(item: ContactJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email")
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validatePastDate("birthDate", true)
      .validateNumber("gradeLevel", 0, 15, true)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateClientContactJsonRequest(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email")
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateString("addressStreet", 100)
      .validateString("addressZip", 100)
      .validateString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validateAllUsingFunction("idDocuments", validateImageJsonAdd, 0, false, 4)
      .validatePastDate("birthDate", true)
      .validateNumber("gradeLevel", 0, 15, true)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateMailingRecipientContactJsonAddNew(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("salutation", 30)
      .validateString("firstName", 100)
      .validateString("lastName", 100)
      .validateString("organisation", 100)
      .validateEmail("email")
      .finish();
}

export function validateMailingRecipientContactJson(item: ContactJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("salutation", 30)
      .validateString("firstName", 100)
      .validateString("lastName", 100)
      .validateString("organisation", 100)
      .validateEmail("email")
      .finish();
}

export function validateEventBookingParticipantContactJsonAddNew(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validatePastDate("birthDate")
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateEventBookingParticipantContactJson(item: ContactJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validatePastDate("birthDate")
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateEventBookingMainContactJsonAddNew(item: ContactJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email")
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}

export function validateEventBookingMainContactJson(item: ContactJson) {
   return new Validation(item)
      .validateInteger("ID", 0, null, true)
      .validateString("remarks", 1000)
      .validateString("salutation", 30)
      .validateString("title", 50)
      .validateString("type", 100)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateString("organisation", 100)
      .validateString("organisationUnit", 100)
      .validateString("organisationPosition", 100)
      .validateEmail("email")
      .validateEmail("emailWork", true)
      .validateString("phone", 100)
      .validateString("phoneWork", 100)
      .validateString("mobile", 100)
      .validateString("mobileWork", 100)
      .validateString("fax", 100)
      .validateString("faxWork", 100)
      .validateString("url", 255)
      .validateNonEmptyString("addressStreet", 100)
      .validateNonEmptyString("addressZip", 100)
      .validateNonEmptyString("addressCity", 100)
      .validateString("addressRegion", 100)
      .validateNonEmptyString("addressCountry", 100)
      .validateString("addressStreetWork", 100)
      .validateString("addressZipWork", 100)
      .validateString("addressCityWork", 100)
      .validateString("addressRegionWork", 100)
      .validateString("addressCountryWork", 100)
      .validateAllUsingFunction("customInputs", validateCustomInputJson)
      .finish();
}